// import { MemoryStorage } from '@/utils/MemoryStorage'
import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'
const routes: Array<RouteRecordRaw> = [
  {
    path: '/:id',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/DHome.vue'),
  },
  {
    // NORMAL的时候
    path: '/end',
    name: 'End',
    component: () => import(/* webpackChunkName: "end" */ '../views/DEnd.vue'),
  },
  {
    path: '/expired',
    name: 'expired',
    component: () => import(/* webpackChunkName: "expired" */ '../views/DEnd.vue'),
  },
  {
    path: '/received',
    name: 'received',
    component: () => import(/* webpackChunkName: "received" */ '../views/DEnd.vue'),
  },
  {
    path: '/tooFrequent',
    name: 'tooFrequent',
    component: () => import(/* webpackChunkName: "tooFrequent" */ '../views/DEnd.vue'),
  },
  {
    path: '/notExist',
    name: 'notExist',
    component: () => import(/* webpackChunkName: "notExist" */ '../views/DEnd.vue'),
  },
  {
    path: '/notStart',
    name: 'notStart',
    component: () => import(/* webpackChunkName: "notStart" */ '../views/DEnd.vue'),
  },
  {
    path: '/networkError',
    name: 'networkError',
    component: () => import(/* webpackChunkName: "networkError" */ '../views/DEnd.vue'),
  },
  // error
  {
    path: '/error',
    name: 'error',
    component: () => import(/* webpackChunkName: "error" */ '../views/DEnd.vue'),
  },
  {
    path: '/preview',
    name: 'Preview',
    component: () => import(/* webpackChunkName: "Preview" */ '../views/DHome.vue'),
  },
  {
    path: '/kyc',
    name: 'Kyc',
    component: () => import(/* webpackChunkName: "Kyc" */ '../views/DKyc.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/noKycAward',
    name: 'NoKycAward',
    component: () => import(/* webpackChunkName: "NoKycAward" */ '../views/NoKycAward.vue'),
  },
  {
    path: '/kycAward',
    name: 'KycAward',
    component: () => import(/* webpackChunkName: "KycAward" */ '../views/KycAward.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/order',
    name: 'Order',
    component: () => import(/* webpackChunkName: "KycAward" */ '../views/DOrder.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/order/success',
    name: 'OrderSuccess',
    component: () => import(/* webpackChunkName: "orderSuccess" */ '../views/orderSuccess.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/order/fail',
    name: 'OrderFail',
    component: () => import(/* webpackChunkName: "orderFail" */ '../views/orderFail.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/notFonud',
    name: 'NotFonud',
    component: () => import(/* webpackChunkName: "notFonud" */ '../views/notFonud.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
